var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-grow-1" },
    [
      _vm.showLabel
        ? _c(
            "v-sheet",
            {
              class:
                _vm.isRequired && _vm.isFocus
                  ? " mrc_text_require primary--text "
                  : _vm.isRequired
                  ? " mrc_text_require text--secondary "
                  : " text--secondary ",
            },
            [_vm._v(_vm._s(_vm.$t(_vm.label)))]
          )
        : _vm._e(),
      _c("v-autocomplete", {
        key: _vm.curkey,
        class: _vm.contentClass,
        attrs: {
          filled:
            _vm.forceFilled || (!_vm.readonly && !_vm.disabled && _vm.filled),
          items: _vm.items,
          "item-text": _vm.itemText,
          "item-value": _vm.itemValue,
          readonly: _vm.readonly,
          chips: _vm.chips || _vm.smallChips,
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
          filter: _vm.filter,
          "allow-overflow": _vm.allowOverflow,
          "small-chips": _vm.smallChips,
          height: _vm.height,
          messages: _vm.messages,
          "hide-details": _vm.hideDetails,
          dense: _vm.dense,
          "search-input": _vm.searchInput,
          rounded: _vm.rounded,
          rules: _vm.rules,
          "no-data-text": _vm.noDataText,
          multiple: _vm.multiple,
          "append-icon": _vm.readonly || _vm.disabled ? "" : _vm.appendIcon,
          "single-line": _vm.singleLine,
          "menu-props": {
            offsetY: true,
            transition: "slide-y-transition",
            rounded: true,
            contentClass: "elevation-4",
          },
          "deletable-chips":
            !_vm.readonly && !_vm.disabled && _vm.deletableChips,
        },
        on: {
          error: function ($event) {
            _vm.isError = true
          },
          blur: function ($event) {
            _vm.isFocus = false
          },
          focus: function ($event) {
            _vm.isFocus = true
          },
          input: function (val) {
            _vm.$emit("input", val)
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "no-data",
              fn: function () {
                return [_c("noContent")]
              },
              proxy: true,
            },
            !_vm.forceNoCheck
              ? {
                  key: "prepend-item",
                  fn: function () {
                    return [
                      _vm.multiple && _vm.items.length > 1
                        ? _vm._t("prepend-item", function () {
                            return [
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "px-4",
                                  attrs: { dense: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.$nextTick(function () {
                                        if (
                                          _vm.curValue.length ===
                                          _vm.items.length
                                        ) {
                                          _vm.curValue = []
                                        } else {
                                          _vm.curValue = []
                                          _vm.items.map(function (item) {
                                            _vm.curValue.push(
                                              item[_vm.itemValue]
                                            )
                                          })
                                        }
                                      })
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-action",
                                    { staticClass: "mx-0 my-0 mr-1" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "material-icons-round",
                                          class:
                                            _vm.curValue.length !== 0 &&
                                            _vm.curValue.length ===
                                              _vm.items.length
                                              ? "primary--text"
                                              : _vm.curValue.length > 0 &&
                                                _vm.curValue.length !==
                                                  _vm.items.length
                                              ? "primary--text"
                                              : "text--secondary",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.curValue.length !== 0 &&
                                                  _vm.curValue.length ===
                                                    _vm.items.length
                                                  ? "check_box"
                                                  : _vm.curValue.length > 0 &&
                                                    _vm.curValue.length !==
                                                      _vm.items.length
                                                  ? "indeterminate_check_box"
                                                  : "check_box_outline_blank"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "label_essweb_system_select_selectAllLabel"
                                              )
                                            )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("v-divider"),
                            ]
                          })
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "selection",
              fn: function (data) {
                return [
                  _vm.customSelection
                    ? [_vm._t("item", null, { data: data })]
                    : [
                        _vm.chips
                          ? [
                              data.index < _vm.$selectSetting.maxChips
                                ? _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        close:
                                          !_vm.readonly &&
                                          !_vm.disabled &&
                                          _vm.deletableChips,
                                        small: _vm.smallChips,
                                        pill: _vm.avatar,
                                        "input-value": data.selected,
                                      },
                                      on: {
                                        click: data.select,
                                        "click:close": function ($event) {
                                          _vm.multiple
                                            ? _vm.removeItem(data.item)
                                            : (_vm.curValue = "")
                                        },
                                      },
                                    },
                                    [
                                      _vm._t("selection.avatar", null, {
                                        data: data,
                                      }),
                                      _vm._t(
                                        "selection",
                                        function () {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    data.item[_vm.itemText]
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                        { data: data }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              data.index === _vm.$selectSetting.maxChips
                                ? _c(
                                    "span",
                                    { staticClass: "text--primary py-2" },
                                    [
                                      _vm._v(
                                        " ..." +
                                          _vm._s(
                                            _vm.curValue.length -
                                              _vm.$selectSetting.maxChips
                                          ) +
                                          " "
                                      ),
                                      !_vm.simple
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_selection_moreItemLabel"
                                                )
                                              ) + " "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : [
                              _c(
                                "span",
                                [
                                  _vm._t(
                                    "selection",
                                    function () {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$getCommonLangValue(
                                                data.item[_vm.itemText]
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                    { data: data }
                                  ),
                                ],
                                2
                              ),
                            ],
                      ],
                ]
              },
            },
            {
              key: "item",
              fn: function (data) {
                return [
                  _vm.customItem
                    ? _vm._t("item", null, { data: data })
                    : _c(
                        "v-list-item",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "px-4 transparent",
                              class: (
                                _vm.multiple
                                  ? _vm.curValue.indexOf(
                                      data.item[_vm.itemValue]
                                    ) != -1
                                  : _vm.curValue &&
                                    String(_vm.curValue) ===
                                      String(data.item[_vm.itemValue])
                              )
                                ? "primary lighten-5"
                                : "transparent",
                              attrs: { dense: _vm.dense },
                            },
                            "v-list-item",
                            data.attrs,
                            false
                          ),
                          data.on
                        ),
                        [
                          _vm.multiple && !_vm.forceNoCheck
                            ? _c(
                                "v-list-item-action",
                                [
                                  _c("v-checkbox", {
                                    staticClass: "primary--text",
                                    attrs: {
                                      value:
                                        _vm.curValue.indexOf(
                                          data.item[_vm.itemValue]
                                        ) != -1,
                                      "input-value":
                                        _vm.curValue.indexOf(
                                          data.item[_vm.itemValue]
                                        ) != -1,
                                      color: "primary",
                                      ripple: false,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.avatar
                            ? _c(
                                "v-list-item-avatar",
                                [_vm._t("item.avatar", null, { data: data })],
                                2
                              )
                            : _vm._e(),
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "text--primary" },
                                [
                                  _vm._t(
                                    "item.title",
                                    function () {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$getCommonLangValue(
                                                data.item[_vm.itemText]
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                    { data: data }
                                  ),
                                ],
                                2
                              ),
                              _vm.twoLine
                                ? _c(
                                    "v-list-item-subtitle",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._t("item.subtitle", null, {
                                        data: data,
                                      }),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                ]
              },
            },
          ],
          null,
          true
        ),
        model: {
          value: _vm.curValue,
          callback: function ($$v) {
            _vm.curValue = $$v
          },
          expression: "curValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }